import React from 'react';
import { Dropdown } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { toggleCatalogSortBy } from 'store/ProductCatalog/controls/actions';
import { getCatalogTotalCount } from 'store/ProductCatalog/products/selectors';
import {
  getCatalogActiveSortBy,
  getCatalogSortByOptions,
} from 'store/ProductCatalog/controls/selectors.jsx';
import FiltersButton from 'pages/ProductCatalog/components/FiltersButton';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const formatProductLabel = (count) => {
  const lastSym = `${count}`.slice(-1);
  /* eslint-disable radix */
  const lastSymNumber = parseInt(lastSym);

  if (count <= 20) {
    if (count === 0) {
      return 'товаров';
    }

    if (count === 1) {
      return 'товар';
    }

    if (count >= 2 && count <= 4) {
      return 'товара';
    }

    if (count > 5) {
      return 'товаров';
    }
  } else {
    if (lastSymNumber === 0) {
      return 'товаров';
    }

    if (lastSymNumber === 1) {
      return 'товар';
    }

    if (lastSymNumber >= 2 && lastSymNumber <= 4) {
      return 'товара';
    }

    if (lastSymNumber > 5) {
      return 'товаров';
    }
  }

  return 'товаров';
};

function ViewFiltersDesktop({
  sortByOptions,
  activeSortBy,
  onSortByChange,
  totalCount,
  showButton,
}) {
  return (
    <div className={cx('double')}>
      <div className={cx('one')}>
        <span className={cx('label')}>
          Найдено {totalCount} {formatProductLabel(totalCount)}
        </span>
      </div>
      <div className={cx('two')}>
        {showButton ?
          <FiltersButton />
        : null}
        <div className={cx('dropdownWrap')}>
          <Dropdown
            onChange={onSortByChange}
            options={sortByOptions}
            theme="main"
            value={activeSortBy}
          />
        </div>
      </div>
    </div>
  );
}

ViewFiltersDesktop.propTypes = {
  sortByOptions: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      label: PropTypes.node,
    }),
  ),
  onSortByChange: PropTypes.func,
  activeSortBy: PropTypes.string,
  totalCount: PropTypes.number,
  showButton: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  sortByOptions: getCatalogSortByOptions(state),
  activeSortBy: getCatalogActiveSortBy(state),
  totalCount: getCatalogTotalCount(state),
});

const mapDispatchToProps = {
  onSortByChange: toggleCatalogSortBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewFiltersDesktop);
